import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoggedInAuthGuard } from './logged-in-auth.guard';
import { GuestAuthGuard } from './guest-auth.guard';

import { HomeComponent } from './routes/home/home.component';
import { OnDemandComponent } from './routes/on-demand/on-demand.component';
import { OnDemandCatalogComponent } from './routes/on-demand-catalog/on-demand-catalog.component';
import { DetailsComponent } from './routes/details/details.component';
import { SearchComponent } from './routes/search/search.component';
import { SettingsComponent } from './routes/settings/settings.component';

/* Account */
import { AccountComponent } from './routes/account/account.component';
import { BillingHistoryComponent } from './routes/account/billing-history/billing-history.component';
import { ChangeEmailComponent } from './routes/account/change-email/change-email.component';
import { ChangePasswordRouteComponent } from './routes/account/change-password-route/change-password-route.component';
import { SubscriptionsComponent } from './routes/account/subscriptions/subscriptions.component';
import { ActivateCouponComponent } from './routes/account/activate-coupon/activate-coupon.component';
import { UpdateSubscriberInfoRouteComponent } from './routes/account/update-subscriber-info-route/update-subscriber-info-route.component';

/* Subscriber */
import { LoginComponent } from './routes/subscriber/login/login.component';
import { TvLoginComponent } from './routes/subscriber/tv-login/tv-login.component';
import { RegisterComponent } from './routes/subscriber/register/register.component';
import { RegisterActivationComponent } from './routes/subscriber/register-activation/register-activation.component';
import { ResetPasswordComponent } from './routes/subscriber/reset-password/reset-password.component';

/* Lists */
import { BookmarksComponent } from './routes/lists/bookmarks/bookmarks.component';
import { MyListComponent } from './routes/lists/my-list/my-list.component';
import { RatesListComponent } from './routes/lists/rates-list/rates-list.component';
import { RentalHistoryListComponent } from './routes/lists/rental-history-list/rental-history-list.component';
import { ViewingListComponent } from './routes/lists/viewing-list/viewing-list.component';

/* Legal Pages */
import { LegalPageComponent } from './routes/legalPages/legal-page/legal-page.component';
import { environment } from 'src/environments/environment';

const routes: Routes = [
  { path: '', component: HomeComponent, runGuardsAndResolvers: 'always' },
  { path: 'home', component: HomeComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'catalogs/:id', component: OnDemandCatalogComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'catalog/:id', component: OnDemandComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'details/:id', component: DetailsComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'search/:key', component: SearchComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'settings', component: SettingsComponent },

  /* Account */
  { path: 'account', component: AccountComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'account/mySubscription', component: SubscriptionsComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'account/billingHistory', component: BillingHistoryComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'account/changeEmail', component: ChangeEmailComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'account/changePassword', component: ChangePasswordRouteComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'account/activateCoupon', component: ActivateCouponComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'account/editInfo', component: UpdateSubscriberInfoRouteComponent, canActivate: [LoggedInAuthGuard] },

  /* Subscriber */
  { path: 'login', component: LoginComponent, canActivate: [GuestAuthGuard] },
  { path: 'register', component: RegisterComponent, canActivate: [GuestAuthGuard] },
  { path: 'register/:token', component: RegisterActivationComponent, canActivate: [GuestAuthGuard] },
  { path: 'resetPassword/:token', component: ResetPasswordComponent, canActivate: [GuestAuthGuard] },

  /* Lists */
  { path: 'lists/bookmarks', component: BookmarksComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'lists/myList', component: MyListComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'lists/rates', component: RatesListComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'lists/rentalsHistory', component: RentalHistoryListComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'lists/viewingHistory', component: ViewingListComponent, canActivate: [LoggedInAuthGuard] },

  /* Legal Pages */
  { path: 'terms', component: LegalPageComponent },
  { path: 'privacy', component: LegalPageComponent },
  { path: 'help', component: LegalPageComponent }
];

if (environment.features.hasTVLogin) {
  routes.push({ path: 'tvlogin', component: TvLoginComponent, canActivate: [LoggedInAuthGuard] });
}

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload', scrollPositionRestoration: 'enabled', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }